export const defaultStyle = {
    rangeCardWrpr: "rangeCardWrpr",
    gradTop: "hidden",
    imageBoxWrpr: "imageBoxWrpr w-full ",
    imgWrpr: "imgWrpr mx-auto w-[80%]",
}
